import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_filter_red.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_filter.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2131145f")

_pushScopeId("data-v-2131145f")
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-sm text-black-lp-100 font-medium" }
const _hoisted_3 = { class: "flex flex-row gap-2 items-center justify-between" }
const _hoisted_4 = { class: "title-wrap flex flex-row gap-2 items-center" }
const _hoisted_5 = { class: "text-base text-gray-lp-800 font-semibold" }
const _hoisted_6 = { class: "actions flex flex-row items-center gap-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-black-lp-100 font-medium text-sm" }, "Filter:", -1)
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  class: "w-5 h-5",
  alt: "filter-icon"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  class: "w-5 h-5",
  alt: "filter-icon"
}
const _hoisted_10 = {
  key: 0,
  class: "error-wrapper"
}
const _hoisted_11 = {
  key: 1,
  class: "table"
}
const _hoisted_12 = {
  key: 0,
  class: "skeleton-list"
}
const _hoisted_13 = {
  class: "col col-name",
  style: {"display":"flex","align-items":"center","gap":"8px"}
}
const _hoisted_14 = { class: "col col-pos" }
const _hoisted_15 = { class: "col col-plm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("dashboard.topCommodity.updatedAt")) + " " + _toDisplayString(_ctx.formatDate(_ctx.lastSyncAt)), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("dashboard.topCommodity.title")) + " (" + _toDisplayString(_ctx.CityCode) + ")", 1),
        _createVNode(_component_TooltipV2, { description: _ctx.tooltipDescription }, null, 8, ["description"])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleToggleMyCommodity && _ctx.handleToggleMyCommodity(...args))),
          class: [
              'rounded-full text-sm border-2 border-red-lp-900 min-w-max px-4 py-2 text-sm font-semibold flex items-center gap-2 min-w-fit whitespace-nowrap transition-colors',
              _ctx.isMyCommodityOnly ? 'text-red-lp-100' : 'text-black-lp-100'
            ]
        }, [
          _createVNode("p", null, _toDisplayString(_ctx.$t("dashboard.topCommodity.yourPos")), 1),
          (_ctx.isMyCommodityOnly)
            ? (_openBlock(), _createBlock("img", _hoisted_8))
            : (_openBlock(), _createBlock("img", _hoisted_9))
        ], 2)
      ])
    ]),
    (_ctx.hasError)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode(_component_ErrorMessage, {
            errorType: 'server',
            onTryAgain: _ctx.retryTopCommodity,
            textButtonSuccess: _ctx.$t('dashboard.topCommodity.retry'),
            customClass: 'h-auto py-6'
          }, null, 8, ["onTryAgain", "textButtonSuccess"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_11, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(20, (i) => {
                  return _createVNode("div", {
                    key: i,
                    class: "row"
                  }, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_Skeleton, {
                        width: "24px",
                        height: "1rem"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "60%",
                        height: "1rem"
                      })
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_Skeleton, {
                        width: "40%",
                        height: "1rem"
                      })
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_Skeleton, {
                        width: "40%",
                        height: "1rem"
                      })
                    ])
                  ])
                }), 64))
              ]))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                (_ctx.items.length > 0)
                  ? (_openBlock(), _createBlock(_component_TableV2, {
                      key: 0,
                      columns: _ctx.tableColumns,
                      data: _ctx.items,
                      isDetailAble: false,
                      isShowCaptionPagination: false,
                      isShowPagination: false,
                      borderTop: false,
                      borderBottom: false,
                      bgHeader: "bg-white border-b border-t rounded-none",
                      isLeftFreeze: _ctx.isMobile,
                      isRightFreeze: false,
                      totalColumnFreeze: 1,
                      totalPercentFreeze: 50
                    }, null, 8, ["columns", "data", "isLeftFreeze"]))
                  : (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 1,
                      customHeaderMessage: _ctx.emptyStateData.headerMessage,
                      customMessage: _ctx.emptyStateData.message,
                      icon: _ctx.emptyStateData.icon
                    }, null, 8, ["customHeaderMessage", "customMessage", "icon"]))
              ], 64))
        ]))
  ]))
})